import { SelectOption } from '../../../../ui/gzDropdown/types';

export const QuarantineHoursDefault: SelectOption = {
  title: '1',
  value: 1,
};

export const QuarantineHoursOptions: Array<SelectOption> = [
  {
    title: '1',
    value: 1,
  },
  {
    title: '2',
    value: 2,
  },
  {
    title: '4',
    value: 4,
  },
  {
    title: '6',
    value: 6,
  },
  {
    title: '8',
    value: 8,
  },
  {
    title: '12',
    value: 12,
  },
  {
    title: '24',
    value: 24,
  },
  {
    title: '48',
    value: 48,
  },
];
